import { useMemo } from "react";
import { useAuth } from "@/shared/session";
import type { FilterField } from "@/ui/filters/filterValues";
import { useGetStorage } from "./useGetStorage";

export const useStorageFilterField = (): FilterField => {
  const { session } = useAuth();
  const { data: storages } = useGetStorage(session?.zone ?? undefined);

  return useMemo(
    () => ({
      type: "select",
      key: "storage",
      label: "Bodega",
      placeholder: "Todas",
      options: storages.map((s) => ({ value: s.id, label: s.name })),
    }),
    [storages],
  );
};
